import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { tenantService } from "@/services/tenantService";
import { TenantInfo } from "@/types/company";
import { getTenantSubdomain } from "@/lib/tenant";

export const isTenantContextRequiredError = (error: unknown): boolean => {
  const err = error as AxiosError<{ detail?: string }>;
  return (
    err.response?.status === 400 &&
    err.response?.data?.detail === "tenant_context_required"
  );
};

export const useTenant = () => {
  const tenantSubdomain =
    typeof window !== "undefined" ? getTenantSubdomain(window.location.hostname) : null;

  return useQuery<TenantInfo | null>({
    queryKey: ["tenant"],
    enabled: Boolean(tenantSubdomain),
    queryFn: async () => {
      try {
        return await tenantService.getCurrentTenant();
      } catch (error) {
        const err = error as AxiosError;
        if (err.response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
    staleTime: 1000 * 60 * 5,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
